// src/components/ChatSound/ChatSound.js
import { useEffect } from "react";
import { getUnlockedAudioContext, installAudioUnlockListener } from "./ShareAudio";

const ChatSound = ({ play, audioSrc, onFinish }) => {
  useEffect(() => installAudioUnlockListener(), []);

  useEffect(() => {
    if (!play || !audioSrc) return;

    let cancelled = false;
    let source;

    const playSound = async () => {
      const ctx = getUnlockedAudioContext();
      if (!ctx) {
        console.warn("[NOTIFICATION_TRACE] SOUND_SKIPPED", {
          reason: "audio-context-not-unlocked",
          audioSrc,
        });
        if (onFinish) onFinish();
        return;
      }

      try {
        const arrayBuf = await fetch(audioSrc).then((res) => res.arrayBuffer());
        const decoded = await new Promise((resolve, reject) => {
          ctx.decodeAudioData(arrayBuf, resolve, reject);
        });

        if (cancelled) return;

        source = ctx.createBufferSource();
        source.buffer = decoded;
        source.connect(ctx.destination);

        source.onended = () => {
          console.info("[NOTIFICATION_TRACE] SOUND_COMPLETED", { audioSrc });
          if (!cancelled && onFinish) onFinish();
        };

        source.start(0);
        console.info("[NOTIFICATION_TRACE] SOUND_STARTED", { audioSrc });
      } catch (err) {
        console.error("[NOTIFICATION_TRACE] SOUND_FAILED", { audioSrc, error: err });
        if (onFinish) onFinish();
      }
    };

    playSound();

    return () => {
      cancelled = true;
      if (source) {
        try {
          source.stop();
        } catch (_) { }
        source.disconnect();
      }
    };
  }, [play, audioSrc, onFinish]);

  return null;
};

export default ChatSound;
